<template>
  <v-footer padless>
    <v-row no-gutters>
      <v-col class="footer-mobilRacing" cols="12">
        <p class="my-2 text-center f20">Powered by Mobil™ <strong class="italic">Mobil Racing Club</strong></p>
      </v-col>
      <v-col class="firstRow footer-shell" cols="12">
        <div class="footer-layout">
          <div class="footer-mainContent">
            <ul class="links-footer">
              <li>
                <a class="font-white link-footer" target="_blank" href="/preguntas-frecuentes">Preguntas frecuentes</a>
              </li>
              <li>
                <a class="font-white link-footer" target="_blank" href="https://www.facebook.com/MobilMexico/">Contacto</a>
              </li>
              <li>
                <a class="font-white link-footer" target="_blank" href="/terminos-y-condiciones">Términos y Condiciones</a>
              </li>
              <li>
                <a class="font-white link-footer" target="_blank"
                  href="https://corporate.exxonmobil.com/Global-legal-pages/privacy-policy_mexico-spanish_marketing">Aviso de privacidad</a>
              </li>
            </ul>

            <ul class="social-footer">
              <li>
                <a class="hover-target" target="_blank" href="https://www.instagram.com/mobilmexico/">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li>
                <a class="hover-target" target="_blank" href="https://www.facebook.com/MobilMexico">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a class="hover-target" target="_blank" href="https://www.linkedin.com/showcase/mobil-mexico/">
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>

            <p class="textFooter">
              © Copyright 2026 Exxon Mobil Corporation. All Rights Reserved.
            </p>
          </div>

          <div class="footer-brandBlock">
            <img :src="require('../../assets/2026/MobilORB_Footer.png')" class="footer-brandImage"
              alt="Oracle Red Bull Racing x Mobil" />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script src="./mobileFooter.js" />
<script src="./mobileFooter.scss" />
<script>
export default {
  name: "mobileFooter",
};
</script>
<style lang="scss" scoped>
.fa-facebook-f,
.fa-instagram,
.fa-linkedin-in {
  color: #000 !important;
}

.termsconds {
  color: #868c96;
  text-decoration: none;
}

.font-white {
  color: #000;
}

a,
i {
  color: #fff;
}

.firstRow {
  background-color: #fff;
}

.textFooter {
  font-family: EMprint;
  font-size: 12px;
  text-align: center;
  color: #000 !important;
  margin: 2px 0 0;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  width: 100% !important;
}

.footer-shell {
  padding: 38px 40px 30px;
}

.footer-layout {
  width: min(100%, 1320px);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 44px;
  padding: 1% 0 1% 0;
}

.footer-mainContent {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
  max-width: 920px;
}

.links-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px 24px;
  text-decoration: none;
  width: 100%;
}

a.font-white.link-footer {
  display: inline-block;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
}

.social-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 26px;
  width: 100%;
  margin-top: 8px;
}

.social-footer::before,
.social-footer::after {
  content: "";
  flex: 1 1 auto;
  height: 1px;
  background-color: rgba(134, 140, 150, 0.25);
}

.social-footer li {
  line-height: 1;
}

.hover-target {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  text-decoration: none;
}

.footer-brandBlock {
  flex: 0 0 232px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.footer-brandImage {
  width: 100%;
  max-width: 232px;
  height: auto;
  display: block;
}

.footer-mobilRacing {
  background-color: #0c479d;
  color: #fff;
}

.f20 {
  font-size: 20px;
}

@media only screen and (max-width: 1260px) {
  .links-footer {
    justify-content: space-around;
    gap: 14px 22px;
  }

  a.font-white.link-footer {
    font-size: 16px;
  }

  .footer-brandBlock {
    flex-basis: 210px;
  }
}

@media only screen and (max-width: 1024px) {
  .footer-shell {
    padding: 32px 24px 26px;
  }

  .footer-layout {
    gap: 22px;
  }

  .links-footer {
    justify-content: center;
    gap: 12px 18px;
  }

  .social-footer {
    gap: 22px;
  }
}

@media only screen and (max-width: 900px) {
  .footer-layout {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .footer-mainContent {
    width: 100%;
    max-width: 680px;
  }

  .footer-brandBlock {
    flex-basis: auto;
    justify-content: center;
    width: 100%;
  }

  .footer-brandImage {
    max-width: min(100%, 340px);
  }

  .links-footer {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 18px;
    justify-items: center;
    max-width: 680px;
  }

  .social-footer {
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media only screen and (max-width: 600px) {
  .footer-shell {
    padding: 26px 18px 24px;
  }

  a.font-white.link-footer {
    font-size: 14px;
  }

  .links-footer {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .social-footer {
    gap: 18px;
  }

  .social-footer::before,
  .social-footer::after {
    min-width: 24px;
  }

  .hover-target {
    font-size: 28px;
  }

  .footer-brandImage {
    max-width: min(100%, 300px);
  }
}
</style>
